import React, { useState, useRef } from "react";
import JawRecordUX from "./JawRecordUX";
import { Button, Form, Icon, Modal } from "semantic-ui-react";
import ModalEditImage from "react-lib/apps/common/ModalEditImage";
import SoftTissueExamUX from "../SoftTissueExamUX";
import ExaminationImageOverlay, { Tooltip } from "./ExaminationImageOverlay"
import { getClinicalTagColor, getClinicalTagMergeColor } from "./FaceRecord";

const JAW_BONES = "Jaw-bones";

const JawRecord = (props) => {
  const [openGallery, setOpenGallery] = useState(false);
  const [openPhysicalExam, setOpenPhysicalExam] = useState(false);
  let tooltipRef = useRef() as any;

  const handleClick = (key) => () => {
    console.log("handleClick key: ", key);
    if (props.selectorMode) {
      const organMaster = props.masterData?.organ?.items.filter((item) => item.hasOwnProperty("settingKey"));
      // console.log(" handleClick organMaster ", organMaster)
      let organ = organMaster.filter((item) => item.settingKey === key);
      // console.log(" handleClick organ ", organ)

      if (organ.length === 1) {
        props.onEvent({ message: "ToggleLocation", params: { items: [{ location: organ[0].nickName }] } });
      } else {
        console.log(" should not see me.");
      }
    }
  };

  const handleMouseOver = (e: any, key: string) => {
    tooltipRef?.show?.({
      target: e.target,
      key,
      masterData: props.masterData,
    });
  };

  const handleMouseLeave = () => {
    tooltipRef.current.style.display = "none";
  };

  let settings = Object.assign({}, defaultSettings);
  const clinicalTagsItems = props.masterData.clinicaltags?.items;
  const organMaster = props.masterData?.organ?.items.filter((item) => item.hasOwnProperty("settingKey"));
  // console.log("OrganMaster ", organMaster)
  const clinical = props.clinicalFindings.find((item) => item.id === props.clinicalFindingId);
  const targetLocation = clinical?.location?.split(",").map((item) => item.trim()) || [];
  const targetClinicaltags = clinical?.clinicaltags?.split(",").map((item) => item.trim()) || [];
  const findClinicalTag = clinicalTagsItems?.find((data) => targetClinicaltags.includes(data.name) && data.diagram === "noteeth");
  let previousList = [];

  for (const item of props.clinicalFindings) {
    let locationList = item?.location?.split(",").map((item) => item.trim()) || [];
    let clinicaltagsList = item?.clinicaltags?.split(",").map((item) => item.trim()) || [];

    for (const keyNickName of locationList) {
      let organ = organMaster.filter((item) => item.nickName === keyNickName);
      let color = "transparent";
      //key ตรงกับ clinical ที่ active อยู่
      if (findClinicalTag && targetLocation?.includes(keyNickName)) {
        // color = findClinicalTag.color[0];
        color = getClinicalTagColor(clinicalTagsItems, targetClinicaltags);
      } else if (targetLocation?.includes(keyNickName)) {
        color = "orange";
      }

      if (!props.clinicalFindingId) {
        const findClinicaltags = props.masterData.clinicaltags?.items?.find((data) => clinicaltagsList.includes(data.name) && data.diagram === "noteeth");

        if (findClinicaltags) {
          const data = getClinicalTagMergeColor({
            clinicalTagsItems,
            clinicaltagsList,
            previousList,
            findClinicaltags,
            keyNickName,
            color,
          });

          color = data.color;
          previousList = data.previousList;
        } else if (locationList?.includes(keyNickName)) {
          color = "orange";
        }
      }

      // if (Object.keys(defaultSettings).includes(key)) {
      if (organ?.length > 0) {
        organ.forEach((element) => {
          settings[element.settingKey] = {
            ...settings[element.settingKey],
            fill: color,
            opacity: "0.7",
          };
        });
      }
      // }
    }
  }

  for (const key in defaultSettings) {
    if (Object.prototype.hasOwnProperty.call(defaultSettings, key)) {
      settings[key] = {
        ...settings[key],
        onClick: handleClick(key),
        style: { pointerEvents: "auto" },
        onMouseOver: (e) => {
          handleMouseOver(e, key);
        },
        onMouseLeave: (e) => {
          handleMouseLeave(e, key);
        },
      };
    }
  }

  //   console.log("settings", settings)

  return (
    <div
      className="jaw-area svg-zoom-out"
      style={{ ...{ cursor: props.selectorMode ? "cell" : "default" }, padding: "20px 0px", display: "flex" }}
      onMouseDown={(e: any) => {
        if (props.selectorMode) {
          e.preventDefault();
        }
      }}
    >
      <Form>
        <ExaminationImageOverlay
          imageKey="jaw"
          sub={props.sub}
          historyReviewSubTab={props.historyReviewSubTab}
          clinicalFindings={props.clinicalFindings}
          filterClinicalFindingIds={props.filterClinicalFindingIds}
          showDrawingChecked={props.showDrawingChecked}
          hideTooltip={true}
          firstPosition={true}
        >
          <JawRecordUX settings={settings} />
        </ExaminationImageOverlay>
      </Form>

      <Tooltip ref={(ref) => (tooltipRef = ref || { current: null })} />
      {/* {props.activeEvaluation ? <Modal
        onClose={() => props.setProp("activeEvaluation", "")}
        // onOpen={() => setOpenPhysicalExam(true)}
        open={props.activeEvaluation === JAW_BONES}
      > <SoftTissueExamUX /> </Modal> : null} */}
    </div>
  );
};

export default JawRecord;

const defaultSettings = {
  jaw1: { fill: "transparent", stroke: "green" },
  jaw2: { fill: "transparent", stroke: "green" },
  jaw3: { fill: "transparent", stroke: "green" },
  jaw4: { fill: "transparent", stroke: "green" },
  jaw5: { fill: "transparent", stroke: "green" },
  jaw6: { fill: "transparent", stroke: "green" },
  jaw7: { fill: "transparent", stroke: "green" },
  jaw8: { fill: "transparent", stroke: "green" },
  jaw9: { fill: "transparent", stroke: "green" },
  jaw10: { fill: "transparent", stroke: "green" },
  jaw11: { fill: "transparent", stroke: "green" },
  jaw12: { fill: "transparent", stroke: "green" },
  jaw13: { fill: "transparent", stroke: "green" },
  jaw14: { fill: "transparent", stroke: "green" },
  jaw15: { fill: "transparent", stroke: "green" },
  jaw16: { fill: "transparent", stroke: "green" },
  jaw17: { fill: "transparent", stroke: "green" },
  jaw18: { fill: "transparent", stroke: "green" },
};
